import { Link } from 'react-router-dom';
import { AmplifyForgotPassword } from '@aws-amplify/ui-react';
import Logo from '../components/Logo';

export default function ForgotPassword() {
  return (
    <div slot="forgot-password" className="flex flex-col items-center">
      <Link to="/">
        <Logo className="w-40 mb-8 -mt-4" />
      </Link>
      <AmplifyForgotPassword usernameAlias="email" headerText="Reset your Password" />
    </div>
  );
}
